import { useState, useMemo, useCallback } from "react";
import Modal from "../components/Modal";
import { ModalContext } from "./ModalContext";

const ModalContextProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalWidth, setModalWidth] = useState("sm");

  const showModal = useCallback((title = "Modal", content, width = "sm") => {
    setModalContent(content);
    setModalTitle(title);
    setModalWidth(width);
    setIsOpen(true);
  }, []);

  const hideModal = useCallback(() => {
    setIsOpen(false);
    setModalContent(null);
    setModalTitle("");
    setModalWidth("sm");
  }, []);

  const contextValue = useMemo(
    () => ({ showModal, hideModal }),
    [showModal, hideModal]
  );

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <Modal
        isOpen={isOpen}
        hideModal={hideModal}
        title={modalTitle}
        content={modalContent}
        width={modalWidth}
      />
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
